import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  Option,
  PositionType,
  SelectComponent
} from '@com-delta-omnichannel/mach';
import { BookWidgetAem } from '../../../models/book-widget-aem.interfaces';
import { BookWidgetFields } from '../../../models/book-widget-fields.interfaces';
import { InfoTooltipComponent } from '../info-tooltip/info-tooltip.component';

@Component({
  selector: 'idp-best-fare-options',
  templateUrl: './best-fare-options.component.html',
  styleUrls: ['./best-fare-options.component.scss'],
  standalone: true,
  imports: [InfoTooltipComponent, SelectComponent]
})
export class BestFareOptionsComponent {
  @Input() bookWidgetAem: BookWidgetAem = {} as BookWidgetAem;
  @Input() bookWidgetFields: BookWidgetFields = {} as BookWidgetFields;
  @Input() toolTipPosition: PositionType = 'bottom-left';
  @Output() bestFareOptionsChange = new EventEmitter<Option>();

  onDropdownSelectionChange(event: Option) {
    this.bestFareOptionsChange.emit(event);
  }
}
